import { VALIDATION_ERROR_MESSAGE } from '../constants/errorMessage';

export const isRequired = (message = VALIDATION_ERROR_MESSAGE.REQUIRED) => {
  return message;
};

export const validateAustralianMobileNumber = (value, erroMessage = VALIDATION_ERROR_MESSAGE.INVALID_MOBILE_NUMBER) => {
  return value.replace(/\s/g, '').startsWith('04') || erroMessage;
};
